export default {
  buyGems: 'buyGems',
  success: 'success'
};
